import { createSlice } from "@reduxjs/toolkit"

import {
  getPosBranchDetails,
  getPosBranches,
  getPosCountryLists,
  getPosDiscounts,
  syncMenu,
  syncPosBranch,
  updateApiKey,
} from "store/actions/posAction"

const initialState = {
  loading: false,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  totalCount: null,
  isUpdating: false,
  currentPage: 1,
  posCountries: [],
  posDiscounts: [],
  posBranches: [],
  posBranchDetails: {},
}

const posSlice = createSlice({
  name: "pos",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET POS COUNTRY LISTS
    builder
      .addCase(getPosCountryLists.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getPosCountryLists.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.totalPages = totalPages
          state.totalCount = totalCount
          state.currentPage = currentPage
          state.posCountries = data
        }
      })
      .addCase(getPosCountryLists.rejected, (state, action) => {
        state.loading = false
      })

    //   UPDATE API KEY
    builder
      .addCase(updateApiKey.pending, state => {
        state.isLoading = true
      })
      .addCase(updateApiKey.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload
        const { id } = action.meta.arg

        if (status) {
          const { apiKey } = data
          //   update the corresponding `apiKey` from response
          state.posCountries = state?.posCountries?.map(country =>
            country._id === id ? { ...country, apiKey } : country
          )
        }
      })
      .addCase(updateApiKey.rejected, (state, action) => {
        state.isLoading = false
      })

    // SYNC MENU
    builder
      .addCase(syncMenu.pending, state => {
        state.isLoading = true
      })
      .addCase(syncMenu.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(syncMenu.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET POS DISCOUNTS
    builder
      .addCase(getPosDiscounts.pending, state => {
        state.posDiscounts = []
      })
      .addCase(getPosDiscounts.fulfilled, (state, action) => {
        const { success, status, data } = action.payload
        if (success || status) {
          state.posDiscounts = data
        }
      })
      .addCase(getPosDiscounts.rejected, (state, action) => {})

    builder
      .addCase(getPosBranches.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getPosBranches.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.totalPages = totalPages
          state.totalCount = totalCount
          state.currentPage = currentPage
          state.posBranches = data
        }
      })
      .addCase(getPosBranches.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getPosBranchDetails.pending, state => {
        state.loading = true
        state.posBranchDetails = {}
      })
      .addCase(getPosBranchDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.posBranchDetails = data
        }
      })
      .addCase(getPosBranchDetails.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(syncPosBranch.pending, state => {
        state.isLoading = true
      })
      .addCase(syncPosBranch.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload
        if (status) {
          // console.log(data)
        }
      })
      .addCase(syncPosBranch.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default posSlice.reducer
